import React, { useLayoutEffect, useRef, useState } from 'react';
import { productPageCopy } from '../../lib/productPageCopy';

// Shared pieces of the two product pages (ProductDetail, FactoryProductDetail).
// Mirrors the mobile repo's src/components/product/ProductPageParts.js — the
// owner's layout of 2026-10-03: name, price, MOQ → trust strip → details →
// description → seller → actions. Nothing here prints "—", "?" or a
// negative line; a part with no data renders nothing.

// Positive lines only. "Verified" only for a verified seller; the payment and
// follow-up lines on every product.
export function TrustStrip({ lang = 'ar', verified = false }) {
  const isAr = lang === 'ar';
  const c = productPageCopy(lang);
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';
  const lines = [verified && c.trustVerified, c.trustPayment, c.trustFollow].filter(Boolean);
  return (
    <ul style={{
      listStyle: 'none', margin: '0 0 16px', padding: '10px 14px',
      background: '#F0F7F0', border: '1px solid rgba(45,106,79,0.14)', borderRadius: 'var(--radius-card)',
      display: 'flex', flexDirection: 'column', gap: 6,
    }}>
      {lines.map((line) => (
        <li key={line} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, lineHeight: 1.55, color: 'var(--text-primary)', fontFamily: font }}>
          <span aria-hidden="true" style={{ color: 'var(--green, #2D6A4F)', fontWeight: 700 }}>✓</span>
          <span>{line}</span>
        </li>
      ))}
    </ul>
  );
}

// Two lines, then "اقرأ المزيد" — the toggle only appears when the text really
// runs past two lines (clamped height < full height).
export function ClampText({ lang = 'ar', text, style }) {
  const c = productPageCopy(lang);
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const body = String(text || '').trim();

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || open) return undefined;
    const measure = () => setOverflows(el.scrollHeight > el.clientHeight + 1);
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [body, open]);

  if (!body) return null;
  const clamp = open ? {} : { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' };
  return (
    <div>
      <p ref={ref} style={{ margin: 0, whiteSpace: 'pre-wrap', ...style, ...clamp }}>{body}</p>
      {(overflows || open) && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          style={{ background: 'none', border: 'none', padding: 0, marginTop: 6, cursor: 'pointer', fontSize: 13, color: 'var(--text-primary)', textDecoration: 'underline', fontFamily: style?.fontFamily }}
        >
          {open ? c.readLess : c.readMore}
        </button>
      )}
    </div>
  );
}
